import { QueryClient } from '@tanstack/react-query';

/**
 * A QueryClient tuned for a back office.
 *
 * `staleTime: 0` and refetch-on-focus are deliberate here (the referee flow turns both off): a
 * reviewer switching back to this tab must see the queue as it is now, not as it was when they
 * left. Two people work this queue at once.
 *
 * `retry: 0` for mutations: every admin action writes an audit row and several are not
 * idempotent (a retried approve re-drives a pipeline). An automatic second attempt is not
 * "resilience" when the first may well have succeeded — the reviewer retries, deliberately.
 */
export function makeQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: 1,
        refetchOnWindowFocus: true,
        staleTime: 0,
      },
      mutations: {
        retry: 0,
      },
    },
  });
}
